/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable no-return-assign */
/* eslint-disable no-restricted-globals */
// 日期格式化
export const time = (date, format = 'yyyy-MM-dd HH:mm:ss') => {
    const pad = (s) => `0${s}`.slice(-2);
    const dt = new Date(+date);
    const parse = {
        MM: dt.getMonth() + 1,
        dd: dt.getDate(),
        HH: dt.getHours(),
        mm: dt.getMinutes(),
        ss: dt.getSeconds(),
    };
    Object.keys(parse).forEach((v) => (parse[v] = pad(parse[v])));
    parse.yyyy = dt.getFullYear();
    return Object.entries(parse).reduce((prev, [k, v]) => {
        prev = prev.replace(k, v);
        return prev;
    }, format);
};

// 距离当前日期
export const getDateFromNow = ({ year = 0, month = 0, day = 0 }) => {
    const dt = new Date();
    dt.setFullYear(dt.getFullYear() + year);
    dt.setDate(dt.getDate() + day);
    return dt;
};

// datePickerOptions.disabledDate
export const disabledDateFn = ({ year = 0, month = 0, day = 0 }) => (time) => time.getTime() < getDateFromNow({ year, month, day });

export const parseTime = (s) => {
    if (isNaN(s)) {
        return '--';
    }

    let t = '';
    if (s > 0) {
        const day = Math.floor(s / (24 * 3600 * 1000));
        const hour = Math.floor((s / (3600 * 1000)) % 24);
        const min = Math.floor((s / (60 * 1000)) % 60);
        const sec = Math.floor((s / 1000) % 60);
        if (day > 0) {
            t = `${day}天`;
        }

        if (hour > 0) {
            t += `${hour}小时`;
        }

        if (min > 0) {
            t += `${min}分`;
        }

        // t += `${sec}秒`;
    }
    return t || '0天';
};

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
